module.exports = __webpack_public_path__ + "assets/img/Compose_Voice.653eab15.svg";